export const ARCHIVE = 'archive'
export const UNSUBSCRIBE = 'unsubscribe'
export const RESUBSCRIBE = 'resubscribe'
